/**
 * Development Environment Configuration
 * 
 * This file contains configurations and mocks specific to the development environment.
 * It should NOT be included in production builds.
 */

// Development environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';

// Check if mocks are enabled from environment variables
const mockingEnabled = process.env.VUE_APP_ENABLE_MOCKS === 'true' || isDevelopment;
const tokenMockingEnabled = process.env.VUE_APP_MOCK_TOKENS === 'true' || isDevelopment;

/**
 * Mock reCAPTCHA configuration for development
 * This allows bypassing the actual reCAPTCHA verification during development
 */
export const mockCaptcha = {
  enabled: mockingEnabled,
  
  // Mock response that simulates a successful verification
  successResponse: 'mock-captcha-response-token',
  
  // Helper methods for the mock implementation
  verify: function(callback) {
    if (this.enabled && callback) {
      console.log('[DEV] Mock reCAPTCHA verification triggered');
      callback(this.successResponse);
      return this.successResponse;
    }
    return null;
  },
  
  reset: function() {
    console.log('[DEV] Mock reCAPTCHA reset called');
    return true;
  },
  
  execute: function() {
    console.log('[DEV] Mock reCAPTCHA execute called');
    return this.successResponse;
  }
};

/**
 * Mock tokens configuration for development
 * This allows bypassing actual email/SMS token delivery during development
 */
export const mockTokens = {
  enabled: tokenMockingEnabled,
  
  // Default tokens for development (always the same for easy testing)
  defaultEmailToken: '123456',
  defaultSmsToken: '654321',
  
  // Log instead of sending tokens in development
  logTokensInsteadOfSending: true,
  
  // Helper method to get mock tokens
  getTokens: function() {
    if (this.enabled) {
      return {
        emailToken: this.defaultEmailToken,
        smsToken: this.defaultSmsToken
      };
    }
    return null;
  },
  
  // Helper method to log token information instead of sending
  logTokenInfo: function(contact) {
    if (this.enabled && this.logTokensInsteadOfSending) {
      console.group('[DEV] Mock Tokens for Development');
      console.log('Token recipient:', contact);
      console.log('Email Token:', this.defaultEmailToken);
      console.log('SMS Token:', this.defaultSmsToken);
      console.log('Use these tokens to authenticate in development environment');
      console.groupEnd();
    }
  }
};

// Console warning about development mode
if (isDevelopment) {
  console.warn('Running in DEVELOPMENT mode with mocks enabled');
  
  // Log mock token status
  if (tokenMockingEnabled) {
    console.info('Mock tokens enabled: Tokens will NOT be sent via email/SMS');
  }
} 